/* Draft Horizon: loading feedback only; native cart and checkout remain in control. */
(() => {
  const isStendos = () => document.querySelector('#cart-drawer .stendos-cart-drawer');
  const timers = new WeakMap();
  const stop = (button) => {
    if (!button) return;
    clearTimeout(timers.get(button));
    button.classList.remove('stendos-is-loading');
    button.removeAttribute('aria-busy');
  };
  const stopAll = () => document.querySelectorAll('button.stendos-is-loading').forEach(stop);
  document.addEventListener('submit', (event) => {
    if (!isStendos()) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if (!form.checkValidity()) return;
    const button = event.submitter || form.querySelector('button[name="add"]');
    if (!button || button.disabled) return;
    button.classList.add('stendos-is-loading');
    button.setAttribute('aria-busy', 'true');
    timers.set(button, setTimeout(() => stop(button), 9000));
  }, true);
  document.addEventListener('click', (event) => {
    if (!isStendos()) return;
    const button = event.target.closest?.('#cart-drawer button#checkout');
    if (!button || button.disabled) return;
    button.classList.add('stendos-is-loading');
    button.setAttribute('aria-busy', 'true');
    timers.set(button, setTimeout(() => stop(button), 12000));
  }, true);
  const drawer = document.getElementById('cart-drawer');
  if (drawer) {
    new MutationObserver(() => {
      if (drawer.hasAttribute('open')) stopAll();
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }
  document.addEventListener('cart:error', stopAll);
})();
